import { ToolHistoryChange } from './ToolHistoryChange';
import { getToolHistoryFieldLabel, TOOL_HISTORY_COPY } from './tool-history-constants';
import {
  ToolHistoryEntryKind,
  type ToolHistoryEntry as HistoryEntry,
} from '@reach/shared-types/tool-history';
import styles from './ToolHistory.module.css';

export const ToolHistoryEntry = ({ entry }: { entry: HistoryEntry }) => {
  const sourceLabel = TOOL_HISTORY_COPY.sources[entry.source];
  const actor = entry.userEmail ?? entry.userId ?? sourceLabel;
  const changedFields = entry.changes.map(change => getToolHistoryFieldLabel(change.field)).join(', ');
  const summary =
    entry.kind && entry.kind !== ToolHistoryEntryKind.UPDATED
      ? TOOL_HISTORY_COPY.initialEntries[entry.kind]
      : changedFields;
  const timestamp = new Date(entry.createdAt).toLocaleString();
  const userIdentity =
    entry.userId && entry.userEmail ? `${TOOL_HISTORY_COPY.userId}: ${entry.userId}` : null;
  return (
    <li className={styles.entry}>
      <details>
        <summary>
          <strong>{actor}</strong>
          {TOOL_HISTORY_COPY.separator}
          <time dateTime={entry.createdAt}>{timestamp}</time>
          <span className={styles.fields}>{summary}</span>
        </summary>
        {userIdentity && <p className={styles.identity}>{userIdentity}</p>}
        {entry.changes.map(change => (
          <ToolHistoryChange key={change.field} change={change} />
        ))}
      </details>
    </li>
  );
};
